import Icon from 'veui/components/Icon'

Icon.register({
  box: {
    paths: [
      {
        d: 'M701.71 244.12l-64-160A32 32 0 00608 64H160a32 32 0 00-29.71 20.12l-64 160A32 32 0 0064 256v416a32 32 0 0032 32h576a32 32 0 0032-32V256a32 32 0 00-2.29-11.88zm-77-20.12H416v-96h170.33zm-443.04-96H352v96H143.27zM128 640V288h512v352zm448-224a32 32 0 01-32 32H416a32 32 0 010-64h128a32 32 0 0132 32zm0 128a32 32 0 01-32 32H288a32 32 0 010-64h256a32 32 0 0132 32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
